export default "__VITE_ASSET__DPEH7djf__"